const DEFAULT_KEY = "coquille.lang";

/**
 * @param {string} storageKey
 * @returns {string | null}
 */
export function readStoredLang(storageKey = DEFAULT_KEY) {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(storageKey);
  } catch {
    return null;
  }
}

/**
 * @param {string} lang
 * @param {string} storageKey
 */
export function writeStoredLang(lang, storageKey = DEFAULT_KEY) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(storageKey, lang);
  } catch {
    /* ignore */
  }
}

export { DEFAULT_KEY as DEFAULT_STORAGE_KEY };
